export class SC_ConfirmationLevelEnum {
    static readonly NA = 1;
    static readonly NO = 2;
    static readonly FIRST = 3;
    static readonly FINAL = 4;

    constructor(private type: number = SC_ConfirmationLevelEnum.NA) { }

    static fromAPI(apiValue: number | string): SC_ConfirmationLevelEnum {
        switch (Number(apiValue)) {
            case SC_ConfirmationLevelEnum.NA:
                return new SC_ConfirmationLevelEnum(SC_ConfirmationLevelEnum.NA);
            case SC_ConfirmationLevelEnum.FINAL:
                return new SC_ConfirmationLevelEnum(SC_ConfirmationLevelEnum.FINAL);
            case SC_ConfirmationLevelEnum.FIRST:
                return new SC_ConfirmationLevelEnum(SC_ConfirmationLevelEnum.FIRST);
            case SC_ConfirmationLevelEnum.NO:
                return new SC_ConfirmationLevelEnum(SC_ConfirmationLevelEnum.NO);
            default:
                return new SC_ConfirmationLevelEnum();
        }
    }

    is(type: number): boolean {
        return this.type === type;
    }

    isSet(): boolean {
        return this.type !== SC_ConfirmationLevelEnum.NA;
    }

    toAPI(): number {
        return this.type;
    }

    clone(): SC_ConfirmationLevelEnum {
        return new SC_ConfirmationLevelEnum(this.type);
    }

    merge(other: SC_ConfirmationLevelEnum): SC_ConfirmationLevelEnum {
        if (other.type !== SC_ConfirmationLevelEnum.NA) {
            this.type = other.type;
        }

        return this;
    }

    static readonly statuses = [
        { key: SC_ConfirmationLevelEnum.FINAL, display: "Final" },
        { key: SC_ConfirmationLevelEnum.FIRST, display: "First" },
        { key: SC_ConfirmationLevelEnum.NO, display: "No" },
        { key: SC_ConfirmationLevelEnum.NA, display: "Not Needed" },
    ];

    toString(): string {
        switch (this.type) {
            case SC_ConfirmationLevelEnum.NA:
                return "N/A";
            case SC_ConfirmationLevelEnum.FINAL:
                return "FINAL";
            case SC_ConfirmationLevelEnum.FIRST:
                return "FIRST";
            default:
                return "NULL";
        }
    }
}
